/**
 * @generated SignedSource<<60dea3de9a9635f6732328087d92dedd>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37

import type { ConcreteRequest, Query } from 'relay-runtime';
export type MediaUploadTokenQueryCommentQuery$variables = {
  cloudId: string;
  contentId: string;
};
export type MediaUploadTokenQueryCommentQuery$data = {
  readonly contentMediaSession: {
    readonly collection: string;
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
    readonly token: {
      readonly value: string;
    };
  } | null | undefined;
};
export type MediaUploadTokenQueryCommentQuery = {
  response: MediaUploadTokenQueryCommentQuery$data;
  variables: MediaUploadTokenQueryCommentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "alias": "contentMediaSession",
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "confluence_commentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaToken",
        "kind": "LinkedField",
        "name": "token",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "clientId"
          },
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "collection"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MediaUploadTokenQueryCommentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MediaUploadTokenQueryCommentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c06482aa2ab100620d21019ae889668d",
    "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
    "metadata": {},
    "name": "MediaUploadTokenQueryCommentQuery",
    "operationKind": "query",
    "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
  }
};
})();

(node as any).hash = "ecbc3538cd4e4434bac2e03ab7969cd8";

export default node;
